export default "__VITE_ASSET__e905dfc0__"